// import logo from './logo.svg';
import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import HomePage from './Pages/HomePage';
import AuthPage from './Pages/AuthPage';
import DocsPage from './Pages/DocsPage';
import DashboardPage from './Pages/DashboardPage';
import AccountSettingsPage from './Pages/AccountSettingsPage';
import ProtectedRoute from './Components/ProtectedRoute';
import ResetPasswordPage from './Pages/ResetPasswordPage';
import ForgotPasswordPage from './Pages/ForgotPasswordPage';
// import SearchPage from './Pages/SearchPage';
import { TermsOfService, PrivacyPolicy,EmailVerificationPage  } from './Pages/SimplePage';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/docs" element={<DocsPage />} />
            {/* <Route path="/search" element={<SearchPage />} /> */}
            <Route path="/login" element={<AuthPage />} />
            <Route path="/register" element={<AuthPage />} />
            <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/account" element={<ProtectedRoute><AccountSettingsPage /></ProtectedRoute>} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/verify-email" element={<EmailVerificationPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          </Routes>
        </Router>
      </div>
    </HelmetProvider>
  );
}

export default App;
